import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import DocsSidebar from '../components/api-docs/DocsSidebar';
import OverviewSection from '../components/api-docs/sections/OverviewSection';
import MerchantSection from '../components/api-docs/sections/MerchantSection';
import PaymentSection from '../components/api-docs/sections/PaymentSection';
import CurrencyBasicSection from '../components/api-docs/sections/CurrencyBasicSection';
import CurrencyAdvancedSection from '../components/api-docs/sections/CurrencyAdvancedSection';
import ReferenceSection from '../components/api-docs/sections/ReferenceSection';

export default function ApiDocs() {
  return (
    <div className="min-h-screen bg-navy-950">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-navy-950/95 backdrop-blur-sm border-b border-navy-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-14 sm:h-16 flex items-center justify-between">
          <Link to="/" className="font-mono text-bone-white tracking-widest text-sm font-medium">
            BONESPAY
          </Link>
          <div className="flex items-center gap-6">
            <span className="font-mono text-xs text-bone-white/40 uppercase tracking-wider hidden sm:block">
              API Documentation
            </span>
            <Link
              to="/"
              className="inline-flex items-center gap-2 font-mono text-xs text-bone-white/60 hover:text-bone-white transition-colors uppercase tracking-wider"
            >
              <ArrowLeft size={14} />
              Back
            </Link>
          </div>
        </div>
      </nav>

      <div className="pt-14 sm:pt-16 flex max-w-7xl mx-auto">
        <aside className="hidden lg:block w-64 flex-shrink-0">
          <div className="sticky top-20 h-[calc(100vh-5rem)] overflow-y-auto py-8 pl-6 pr-4 scrollbar-thin">
            <DocsSidebar />
          </div>
        </aside>

        <main className="flex-1 min-w-0 px-4 sm:px-6 lg:pl-8 lg:pr-12 py-10">
          <OverviewSection />
          <MerchantSection />
          <PaymentSection />
          <CurrencyBasicSection />
          <CurrencyAdvancedSection />
          <ReferenceSection />

          <div className="mt-16 border-t border-navy-800/50 pt-6">
            <p className="font-mono text-[10px] text-bone-white/20 uppercase tracking-wider">
              &copy; {new Date().getFullYear()} BonesPay &mdash; A BONES R&D Project.
            </p>
          </div>
        </main>
      </div>
    </div>
  );
}
